/**
 * 利润报表配置
 * 表头/表格字段固化在本地，抽离为独立文件
 */

import { getLoginName } from '@/utils/util'

export const BILL_TYPE = 'SALE_PROFIT'
export const REPORT_TITLE = '销售利润'

// 表格列定义（16列）
export const defColumns = [
  {
    title: '序号',
    dataIndex: 'rowIndex',
    width: 50,
    align: 'center',
    customRender: function (t, r, index) {
      return (t !== '合计') ? (parseInt(index) + 1) : t
    }
  },
  {
    title: '单据编号',
    dataIndex: 'number',
    width: 130,
    ellipsis: true,
    scopedSlots: { customRender: 'numberCustomRender' }
  },
  { title: '条码', dataIndex: 'barCode', width: 100, ellipsis: true },
  { title: '名称', dataIndex: 'mName', width: 120, ellipsis: true },
  { title: '规格', dataIndex: 'standard', width: 60, ellipsis: true },
  { title: '型号', dataIndex: 'model', width: 60, ellipsis: true },
  { title: '单位', dataIndex: 'mUnit', width: 50, ellipsis: true },
  { title: '数量', dataIndex: 'operNumber', width: 70, align: 'right', sorter: true },
  { title: '销售单价', dataIndex: 'unitPrice', width: 80, align: 'right', sorter: true },
  { title: '成本价', dataIndex: 'purchaseUnitPrice', width: 80, align: 'right', sorter: true },
  { title: '销售金额', dataIndex: 'salePrice', width: 80, align: 'right', sorter: true },
  { title: '成本金额', dataIndex: 'purchasePrice', width: 80, align: 'right', sorter: true },
  { title: '利润', dataIndex: 'profitPrice', width: 80, align: 'right', sorter: true },
  { title: '利润率', dataIndex: 'profitRate', width: 70, align: 'right', sorter: true },
  { title: '税率', dataIndex: 'taxRate', width: 60, align: 'right' },
  { title: '客户或会员', dataIndex: 'sName', width: 100, ellipsis: true }
]

// 打印数据构建 - 将列表数据 + 查询条件映射为打印字段
export function buildPrintData(dataSource, queryParam, userInfo, companyInfo) {
  // 提取合计行
  const totalRow = (dataSource || []).find(item => item.rowIndex === '合计')

  // 过滤合计行，映射数据行
  const rows = (dataSource || [])
    .filter(item => item.rowIndex !== '合计')
    .map((item, idx) => ({
      rowIndex: idx + 1,
      number: item.number || '',
      barCode: item.barCode || '',
      mName: item.mName || '',
      standard: item.standard || '',
      model: item.model || '',
      mUnit: item.mUnit || '',
      operNumber: item.operNumber || 0,
      unitPrice: item.unitPrice || 0,
      purchaseUnitPrice: item.purchaseUnitPrice || 0,
      salePrice: item.salePrice || 0,
      purchasePrice: item.purchasePrice || 0,
      profitPrice: item.profitPrice || 0,
      profitRate: item.profitRate || 0,
      taxRate: item.taxRate || 0,
      sName: item.sName || ''
    }))

  // 追加合计行到表格末尾
  if (totalRow) {
    rows.push({
      rowIndex: '合计',
      number: '',
      barCode: '',
      mName: '',
      standard: '',
      model: '',
      mUnit: '',
      operNumber: totalRow.operNumber || 0,
      unitPrice: totalRow.unitPrice || 0,
      purchaseUnitPrice: totalRow.purchaseUnitPrice || 0,
      salePrice: totalRow.salePrice || 0,
      purchasePrice: totalRow.purchasePrice || 0,
      profitPrice: totalRow.profitPrice || 0,
      profitRate: totalRow.profitRate || '-',
      taxRate: totalRow.taxRate || '-',
      sName: ''
    })
  }

  return {
    reportTitle: REPORT_TITLE,
    reportDate: new Date().toLocaleDateString(),
    dateRange: (queryParam && queryParam.beginTime && queryParam.endTime)
      ? queryParam.beginTime + ' ~ ' + queryParam.endTime : '',
    table: rows,
    total_salePrice: 0,
    total_purchasePrice: 0,
    total_profitPrice: 0,
    creatorName: getLoginName(),
    companyName: (companyInfo && companyInfo.companyName) || '',
    companyAddress: (companyInfo && companyInfo.companyAddress) || '',
    companyTel: (companyInfo && companyInfo.companyTel) || '',
    companyFax: (companyInfo && companyInfo.companyFax) || ''
  }
}